import { render, staticRenderFns } from "./PopList.vue?vue&type=template&id=16f707a2&scoped=true&"
import script from "./PopList.vue?vue&type=script&lang=js&"
export * from "./PopList.vue?vue&type=script&lang=js&"
import style0 from "./PopList.vue?vue&type=style&index=0&id=16f707a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f707a2",
  null
  
)

export default component.exports